/**
 * Services file for CRM which invokes its own API endpoints.
 */

const BASE_API_URL = '/api/data/v9.1';

export const Services = {
  MY_CLAIMS: {
    BENEFIT_QUOTES: {
      GET_MEMBERS_PRODUCTS_AND_MODALITIES: `${BASE_API_URL}/dhl_FetchModalitiesforBenefitQuote`,
      GET_MODALITIES_AND_CLAIM_ACCOUNTS: `${BASE_API_URL}/dhl_FetchModalitiesandClaimsAccountDetailsforClaims`,
      GET_PROVIDERS_FOR_SELECTED_MODALITY: `${BASE_API_URL}/dhl_FetchModalityProvidersForGetBenefitQuote`,
      GET_SERVICES_FOR_SELECTED_MODALITY: `${BASE_API_URL}/dhl_FetchModalityServicesForGetBenefitQuote`,
      GET_BENEFIT_QUOTE_DETAILS: `${BASE_API_URL}/dhl_FetchBenefitQuote`,
      GET_TOOTH_ID_REFERENCE_DATA: `${BASE_API_URL}/dhl_tooths?$select=dhl_toothcode,dhl_name`,
      SUBMIT_BENEFIT_QUOTE: `${BASE_API_URL}/dhl_SubmitBenefitQuote`,
      SEARCH_BENEFIT_QUOTES: `${BASE_API_URL}/dhl_SearchBenefitQuotes`,
    },
  },
  MY_COVER: {
    PAYMENTS: {
      MAKE_A_PAYMENT: {
        GET_SURCHARGE_TEXT: `${BASE_API_URL}/dhl_configurations?$select=dhl_name,dhl_value&$filter=dhl_name eq 'CreditCardSurchargeText'`,
        GET_MAXIMUM_PAYMENT_AMOUNT: `${BASE_API_URL}/dhl_RetrieveProrataPrice`,
        MAKE_PAYMENT: `${BASE_API_URL}/dhl_SubmitPayment`,
      },
      PAYMENT_HISTORY: {
        GET_PAYMENT_HISTORY: `${BASE_API_URL}/dhl_MembershipPayments`,
        GET_CONTRIBUTION_BREAKDOWN: `${BASE_API_URL}/dhl_MembershipContributionBreakdown`,
      },
    },
  },
  MEMBERSHIP_CARD: {
    GET_LAST_ORDER: `${BASE_API_URL}/dhl_RetrieveLastCardOrder`,
    GET_ADDRESS: (memberNumber, personCode) => {
      return `${BASE_API_URL}/dhl_membershipmemberses?$select=dhl_memberid,dhl_membershipid,dhl_addresslineonepostal,dhl_addresslinetwopostal,dhl_addresslinethreepostal,dhl_suburb,dhl_state,dhl_postcode,dhl_dpid,dhl_membershipmembersid&$expand=dhl_Membership($select=dhl_membershipid,dhl_relatedmemberid,dhl_startdateofpolicy,dhl_addresslineoneresidential,dhl_addresslinetworesidential,dhl_addresslinethreeresidential,dhl_suburbresidential,dhl_state,dhl_postcoderesidential,dhl_dpid)&$filter=dhl_membershipid eq '${memberNumber}' and dhl_memberid eq '${personCode}'`;
    },
    SUBMIT_NEW_CARD_ORDER: `${BASE_API_URL}/dhl_GenerateMemberCards`,
  },
};
